import { FilterFactory } from "./filterFactory";

const FILTER_STORAGE_KEY = "stored_filters";

export class FilterManager {
  constructor(filters) {
    this.filters = filters;
    this.filterMap = {};
    for (const filter of filters) {
      this.filterMap[filter.filterType] = filter;
    }
  }

  setValue(filterType, value) {
    if (filterType in this.filterMap) {
      this.filterMap[filterType].setValue(value);
    }
  }

  setFrom(filterType, value) {
    if (filterType in this.filterMap) {
      this.filterMap[filterType].setFrom(value);
    }
  }

  setTo(filterType, value) {
    if (filterType in this.filterMap) {
      this.filterMap[filterType].setTo(value);
    }
  }

  setElement(filterType, value) {
    if (filterType in this.filterMap) {
      this.filterMap[filterType].setElement(value);
    }
  }

  getFilter(filterType) {
    return this.filterMap[filterType];
  }

  getHeaders() {
    return this.filters.map((filter) => {
      return {
        id: filter.filterType,
        display: filter.visibility,
        type: filter.dataType,
        label: filter.filterName,
        info: filter.information,
        orderMap: filter.orderMap
      }
    });
  }

  getActiveFilters() {
    return this.getFilterableFilters().filter((filter) => (filter.value || filter.value === 0 || filter.from || filter.to));
  }

  getFilterableFilters() {
    return this.filters.filter((filter) => filter.filterable);
  }

  getFilterObject() {
    const valueMap = {};
    for (const filter of this.getActiveFilters()) {
      valueMap[filter.filterType] = {
        value: filter.value,
        from: filter.from,
        to: filter.to
      };
    }
    return valueMap;
  }

  filterData(data) {
    return this.getActiveFilters().reduce((accumulator, current) => current.filterData(accumulator), data);
  }

  saveFilters() {
    localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(this.getFilterObject()));
  }

  clearSavedFilters() {
    localStorage.removeItem(FILTER_STORAGE_KEY);
    for (const filter of this.filters) {
      filter.value = null;
      filter.from = null;
      filter.to = null;
    }
  }

  getComparator(order, orderBy) {
    const filter = this.getFilter(orderBy);
    return order === "desc"
        ? (a, b) => filter.compare(a, b)
        : (a, b) => -filter.compare(a, b);
  }

  generateDataMap(device, deviceGroups, insight, insightMetrics, update, alert, user, alg_meta, alg_release) {
    const valueMap = {};
    for (const filter of this.filters) {
      valueMap[filter.filterType] = filter.formatData(device, deviceGroups, insight, insightMetrics, update, alert, user, alg_meta, alg_release);
    }
    return valueMap;
  }

  static get Builder() {
    class Builder {
      constructor() {
        this.restrictToScope = false;
        this.filters = [];
      }

      addFilter(filterType, visibility) {
        this.filters.push({filterType, visibility});
        return this;
      }

      setRestrictToScope(restrictToScope) {
        this.restrictToScope = restrictToScope;
        return this;
      }

      setCompareWith(allowCompare) {
        this.allowCompare = allowCompare;
        return this;
      }

      build() {
        const existingFilters = JSON.parse(localStorage.getItem(FILTER_STORAGE_KEY)) || {};
        const filterManager = new FilterManager(this.filters.map((filter) => FilterFactory.getFilter(filter.filterType, filter.visibility, this.restrictToScope, this.allowCompare)));
        for (const filter of filterManager.filters) {
          const filterData = existingFilters[filter.filterType];
          if (filterData) {
            filter.value = filterData.value;
            filter.from = filterData.from;
            filter.to = filterData.to;
          }
        }
        return filterManager;
      }
    }
    return new Builder();
  }
}